<template>
    <div class="home_cox">
        <div class="body">
            <div class="body_top">
                <el-tabs v-model="activeHit" type="card" style="width: 100%;" @tab-click="handleClickTop">
                    <el-tab-pane :label="'今日点击量 '+todayHits" name="today">
                    </el-tab-pane>
                    <el-tab-pane :label="'总点击量 '+totalHits" name="total">
                    </el-tab-pane>
                </el-tabs>
                <div class="body_menu">
                    <div style="margin:20px;margin-bottom: 60px; position: relative;" class="menu_box" v-for="item in pageViews" :key="item.id">

                        <!-- <div  class="img" style="position: absolute;filter: brightness(0.5);" :style="{ 'background-image':'url('+resouse+item.background+')',}"></div>
                        <div @click="open(item)" class="img" style="position: relative;z-index: 2;">
                            <span style="text-align:center;filter: brightness(1);">
                                <img style="width: 32px;height: 32px; margin-bottom:16px; position: absolute;left: 100px;top: -15px;" :src='resouse+item.icon' alt="" srcset="">
                                <div class="wenzi">{{item.name}}</div>
                            </span>
                        </div> -->


                        <img class="tupain" :src="resouse+item.background" alt="" srcset="">
                        <div class="wenzi">
                            <div style="color: #999;width: 120px;">{{item.name}}</div>
                            <div>{{todayOrtotal?item.todayHits:item.totalHits}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="footer_box">
                <div style="display: flex;">
                    <span style="width: 150px;font-size: 18px; ">登录会员占比</span>
                    <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 100%;">
                        <el-tab-pane label="今日" name="first"></el-tab-pane>
                        <el-tab-pane label="总计" name="second"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="echars_box" >
                    <div v-for="(item,index) in loginProportion" :id="'chart'+index"  style="width: 250px; height:250px;"></div>
                    <!-- <div ref="chart2" style="width: 250px; height:250px;"></div>
                    <div ref="chart3" style="width: 250px; height:250px;"></div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import resouse from '../../utils/video.js'
    export default {
        data(){
            return{
                activeName: 'first',
                activeHit:"today",
                riskAll:"25%",
                pageViews:[],
                loginProportion:[],
                todayOrtotal:true,
                todayOrtotalP:true,
                myChart:[],
                todayHits:0,
                totalHits:0,
                resouse:resouse
            }
        },
        created(){
            
        },
        mounted(){
            new Promise(resolve => {
                this.getLoginPro();
                // console.log("再调用数据");
            }).then(res => {
                // console.log("数据返回了",res);//数据返回了
            }),
            this.getPageView();
        },
        methods:{
            //获取菜单点击量
            getPageView(){
                this.$http.get(`/statistics/hits`).then((res)=>{
                    if(res.code==200){
                        console.log(res.data);
                        // res.data.modules.forEach(item => {
                        //     item.totalHits="总"+item.totalHits;
                        // });
                        this.pageViews=res.data.modules;
                        this.todayHits=res.data.todayHits;
                        this.totalHits=res.data.totalHits;
                    }else{
                        this.$message.error("获取点击量失败")
                    }
                })
            },
            //获取登录会员占比
            getLoginPro(){
                this.$http.get(`/statistics/loginProportion`).then((res)=>{
                    if(res.code==200){
                        // res.data.forEach(item => {
                        //     item.totalProportion="总"+item.totalProportion
                        // });
                        this.loginProportion=res.data;
                        // console.log(this.loginProportion);
                        setTimeout(()=>{
                            this.initCharts();
                        },1000)
                    }else{
                        this.$message.error("获取登录会员占比失败")
                    }
                })
            },
            //顶部今日和总的点击量切换事件
            handleClickTop(){
                this.todayOrtotal=!this.todayOrtotal
            },
            //底部菜单切换事件
            handleClick(tab, event) {
                // console.log(tab, event);
                
                this.todayOrtotalP=!this.todayOrtotalP;
                // this.myChart.forEach(item=>{
                //     var option =item.getOption();
                //     item.setOption(option);
                //     // console.log(item.getOption());
                //     // item.dispose()
                    
                // })
                for (let i = 0; i < this.myChart.length; i++) {
                    this.setChartOption(this.myChart[i], i)
                }
                // this.myChart=[]
                // this.initCharts()
                // var option =this.myChart1.getOption();
                // this.myChart1.setOption(option);
                // var option =this.myChart2.getOption();
                // this.myChart2.setOption(option);
                // var option =this.myChart3.getOption();
                // this.myChart3.setOption(option);

                // this.loginProportion.forEach(item => {
                //     item.totalProportion="总"+item.totalProportion
                // });
            },
            setChartOption(chart, i){
                chart.setOption({
                        color: ['#0094F6', '#E9E9E9'],
                        series: [
                            {
                                name: 'Access From',
                                type: 'pie',
                                radius: ['40%', '70%'],
                                avoidLabelOverlap: false,
                                label: {
                                    show: false,
                                    position: 'center'
                                },
                                label: {
                                    position: 'center',
                                    show: true,
                                    formatter:() => {
                                        let str = `${this.loginProportion[i].name}`
                                        +'\n'+ 
                                        `${this.todayOrtotalP?this.loginProportion[i].todayProportion:this.loginProportion[i].totalProportion}%`
                                        return str
                                    },
                                    color: '#000',
                                    lineHeight: 16,
                                    fontSize: 12,
                                },
                                labelLine: {
                                    show: false
                                },
                                data: [
                                    { value: `${this.todayOrtotalP?this.loginProportion[i].todayProportion:this.loginProportion[i].totalProportion}`,name:"proportion"},
                                    { value: 100-`${this.todayOrtotalP?this.loginProportion[i].todayProportion:this.loginProportion[i].totalProportion}`,name:"other"},
                                ]
                            }
                        ],
                    })
            },
            initCharts () {
                // console.log(document.getElementById(`chart1`));
                for(let i=0;i<this.loginProportion.length;i++){
                    let chart=this.$echarts.init(document.getElementById(`chart${i}`));
                    this.setChartOption(chart, i)
                    this.myChart.push(chart)
                }
                //  this.myChart1 = this.$echarts.init(this.$refs.chart1);
                //  this.myChart2 = this.$echarts.init(this.$refs.chart2);
                //  this.myChart3 = this.$echarts.init(this.$refs.chart3);
                // this.todayOrtotalP=!this.todayOrtotalP;
                // 绘制图表
                // this.myChart1.setOption({
                //     color: ['#0094F6', '#E9E9E9'],
                //     series: [
                //         {
                //             name: 'Access From',
                //             type: 'pie',
                //             radius: ['40%', '70%'],
                //             avoidLabelOverlap: false,
                //             label: {
                //                 show: false,
                //                 position: 'center'
                //             },
                //             label: {
                //                 position: 'center',
                //                 show: true,
                //                 formatter:() => {
                //                     let str = `${this.loginProportion[0].name}`
                //                     +'\n'+ 
                //                     `${this.todayOrtotalP?this.loginProportion[0].todayProportion+'2':this.loginProportion[0].todayProportion+'1'}`
                //                     return str
                //                 },
                //                 color: '#000',
                //                 lineHeight: 16,
                //                 fontSize: 12,
                //             },
                //             labelLine: {
                //                 show: false
                //             },
                //             data: [
                //                 { value: 1048, name: 'Search Engine' },
                //                 { value: 735, name: 'Direct' },
                //             ]
                //         }
                //     ],
                // });
                // this.myChart2.setOption({
                //     color: ['#FEC03D', '#E9E9E9'],                    
                //     series: [
                //         {
                //             name: 'Access From',
                //             type: 'pie',
                //             radius: ['40%', '70%'],
                //             avoidLabelOverlap: false,
                //             label: {
                //                 show: false,
                //                 position: 'center'
                //             },
                //             label: {
                //                 position: 'center',
                //                 show: true,
                //                 formatter:() => {
                //                     let str = `${this.loginProportion[1].name}`
                //                     +'\n'+ 
                //                     `${this.todayOrtotalP?this.loginProportion[1].todayProportion+"11":this.loginProportion[1].todayProportion+"222"}`
                //                     return str
                //                 },
                //                 color: '#000',
                //                 lineHeight: 16,
                //                 fontSize: 12,
                //             },
                //             labelLine: {
                //                 show: false
                //             },
                //             data: [
                //                 { value: 1048, name: 'Search Engine' },
                //                 { value: 735, name: 'Direct' },
                //             ]
                //         }
                //     ],
                // });
                // this.myChart3.setOption({
                //     color: ['#8167F5', '#E9E9E9'],
                //     series: [
                //         {
                //             name: 'Access From',
                //             type: 'pie',
                //             radius: ['40%', '70%'],
                //             avoidLabelOverlap: false,
                //             label: {
                //                 show: false,
                //                 position: 'center'
                //             },
                //             label: {
                //                 position: 'center',
                //                 show: true,
                //                 formatter:() => {
                //                     let str = `${this.loginProportion[2].name}`
                //                     +'\n'+ 
                //                     `${this.todayOrtotalP?this.loginProportion[2].todayProportion+"777":this.loginProportion[2].todayProportion+"666"}`
                //                     return str
                //                 },
                //                 color: '#000',
                //                 lineHeight: 16,
                //                 fontSize: 12,
                //             },
                //             labelLine: {
                //                 show: false
                //             },
                //             data: [
                //                 { value: 1048, name: 'Search Engine' },
                //                 { value: 735, name: 'Direct' },
                //             ]
                //         }
                //     ],
                // });
            },
        }
    }
</script>

<style lang="less" scoped>
.home_cox{
    width: 100%;
    height: 100%;
    box-sizing: border-box ;
    background: #fff;
    min-height: 829px;
    padding: 10px 20px;
    .body{
        width: 100%;
        height: 65%;
        .body_top{
            width: 100%;
            // display: flex;
            // justify-content: space-around;
            // align-items: center;
            .body_menu{
                width: 86%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                overflow: auto;
                flex-wrap: wrap;
                margin: 0 auto;
                .menu_box{
                    width: 22%;
                    display: flex;
                    justify-content: space-around;
                    // border: 1px solid #000;
                    .img{
                        width: 95px;
                        height: 95px;
                        border-radius: 25px;
                        margin-right:30px;
                        margin-bottom:21px;
                        background-size: 100%;
                        background-position: center center;
                        background-image:rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        // cursor: pointer;

                    }
                    .tupain{
                        width: 120px;
                        // height: 120px;
                        // margin-bottom: 40px;
                        object-fit: contain;
                    }
                    .wenzi div{
                        font-size: 30px;
                    }
                }
            }
        }
    }
    .footer{
        width: 100%;
        height: 200px;
        // background: green;
        .footer_box{
            height: 40px;
            line-height: 40px;
            // display: flex;
            // align-content: center;
            // justify-content: left;
            .echars_box{
                display: flex;
                justify-content: space-around;
            }

        }
    }
}
</style>